export default {
  "USD": "🇺🇸",
  "GBP": "🇬🇧",
  "CAD": "🇨🇦",
  "JPY": "🇯🇵",
  "AED": "🇦🇪",
  "EUR": "🇪🇺",
  "AUD": "🇦🇺",   // Australian Dollar
  "CHF": "🇨🇭",   // Swiss Franc
  "CNY": "🇨🇳",   // Chinese Yuan
  "INR": "🇮🇳",   // Indian Rupee
  "RUB": "🇷🇺",   // Russian Ruble
  "BRL": "🇧🇷",   // Brazilian Real
  "ZAR": "🇿🇦",   // South African Rand
  "KRW": "🇰🇷",   // South Korean Won
  "MXN": "🇲🇽",   // Mexican Peso
  "SGD": "🇸🇬",   // Singapore Dollar
  "SEK": "🇸🇪",   // Swedish Krona
  "TRY": "🇹🇷",   // Turkish Lira
  "HKD": "🇭🇰",   // Hong Kong Dollar
  "NZD": "🇳🇿"    // New Zealand Dollar
}